<ng-container *ngIf="signedVacationsItem">
  <div>
    <h6 class="u-h6 u-dark-grey" data-e2e-class="year">{{ signedVacationsItem.year }}</h6>
  </div>
  <img src="assets/imgs/signed-timetables/download-signed-timetable.svg" alt="Signed vacations" item-end />
</ng-container>
